module.exports = [{"featureType":"landscape","stylers":[{"color":"#dfe4ea"}]},{"featureType":"landscape.man_made","elementType":"geometry","stylers":[{"color":"#c8d6e6"},{"visibility":"on"}]},{"featureType":"landscape.man_made","elementType":"geometry.fill","stylers":[{"color":"#d0dde8"},{"visibility":"off"}]},{"featureType":"landscape.man_made","elementType":"geometry.stroke","stylers":[{"color":"#81a0c5"}]},{"featureType":"water","stylers":[{"color":"#85b6c9"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Contacts/gmapStyles.json
// module id = Cl1B
// module chunks = 0